import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../../Images/Banner/recognisation-banner.webp";
import classroomImage from "../../Images/gov-body/rules.webp";
import { Row } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import "../../Placement.css";
import acc from "../../Images/accrediations/aacsb.webp";

const AACSB = () => {
  return (
    <>
      <title>AACSB Accredited Business School | ISBM University</title>
      <meta
        name="description"
        content="ISBM University is AACSB accredited, offering globally recognized business programs with industry-focused curriculum for future-ready leaders."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="conatiner-xxl">
            <div className="section-hero-content">
              <h1>AACSB – Excellence in Business Education</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  AACSB
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section class="ptb-50">
        <div class="container-xxl">
          <h2 class="section-title modern-title text-center text-blue">
            ISBM University – Driving Global Standards with AACSB Principles
          </h2>
          <p class="text-center mx-auto">
            Committed to advancing quality business education recognized
            worldwide.
          </p>

          <div class="row g-4 mt-5">
            <div class="col-12">
              <div class="modern-health">
                <div class="row g-0 h-100">
                  <div class="col-md-6 order-md-1 position-relative">
                    <div class="health-image-container">
                      <div class="health-background-block bg-purple"></div>
                      <img
                        src={acc}
                        alt="Sports Activities"
                        class="health-image"
                      />
                    </div>
                  </div>
                  <div class="col-md-6 order-md-2">
                    <p>
                      The Association to Advance Collegiate Schools of Business
                      (AACSB) is a global accreditation body recognized as the
                      gold standard for business education. ISBM University
                      aligns with AACSB principles of innovation, impact, and
                      engagement, ensuring that our business and management
                      programs meet global quality benchmarks.
                    </p>
                    <p>
                      Our goal is to nurture future-ready business leaders
                      through cutting-edge curriculum, research-oriented
                      learning, and industry integration—all inspired by the
                      standards set by AACSB.
                    </p>
                    <h3 class="fw-bold mb-3">
                      Key Highlights of NAAC Accreditation
                    </h3>

                    <div class="health-highlights mb-3">
                      <div class="health-highlight-item">
                        <i class="ti ti-check"></i> Focus on innovation,
                        leadership, and impactful research.
                      </div>
                      <div class="health-highlight-item">
                        <i class="ti ti-check"></i> Curriculum designed to meet
                        international business education standards.
                      </div>
                      <div class="health-highlight-item">
                        <i class="ti ti-check"></i>Emphasis on experiential
                        learning, practical exposure, and entrepreneurship.
                      </div>
                      <div class="health-highlight-item">
                        <i class="ti ti-check"></i> Collaboration with global
                        business schools for knowledge exchange.
                      </div>
                      <div class="health-highlight-item">
                        <i class="ti ti-check"></i> Strong industry connect for
                        internships, placements, and career growth.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default AACSB;
